import { render } from "./StorySyndication.vue.js?vue&type=template&id=013580ba!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StorySyndication.vue?vue&type=template&id=013580ba"
import script from "./StorySyndication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StorySyndication.vue?vue&type=script&lang=js"
export * from "./StorySyndication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StorySyndication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/StorySyndication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "013580ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('013580ba', __exports__)) {
    api.reload('013580ba', __exports__)
  }
  
  module.hot.accept("./StorySyndication.vue.js?vue&type=template&id=013580ba!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StorySyndication.vue?vue&type=template&id=013580ba", () => {
    api.rerender('013580ba', render)
  })

}


export default __exports__